import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
// Pages
import { Home } from './pages/Home';
import { Bedrijfswaardering } from './pages/Bedrijfswaardering';
import { Werkwijze } from './pages/Werkwijze';
import { Kennisbank } from './pages/Kennisbank';
import { BlogPost } from './pages/BlogPost';
import { Adviseurs } from './pages/Adviseurs';
import { AdviseurDetail } from './pages/AdviseurDetail';
import { OverOns } from './pages/OverOns';
import { Contact } from './pages/Contact';
import { Cases } from './pages/Cases';
import { CaseDetail } from './pages/CaseDetail';
const PAGE_TITLES: Record<string, string> = {
  '/': 'Mijn Bedrijfswaarderingen | Onafhankelijke bedrijfswaardering voor MKB',
  '/bedrijfswaardering': 'Bedrijfswaardering | Mijn Bedrijfswaarderingen',
  '/bedrijfswaardering-verkoop': 'Bedrijfswaardering bij Verkoop | Mijn Bedrijfswaarderingen',
  '/bedrijfswaardering-overname': 'Bedrijfswaardering bij Overname | Mijn Bedrijfswaarderingen',
  '/bedrijfswaardering-scheiding': 'Bedrijfswaardering bij Scheiding | Mijn Bedrijfswaarderingen',
  '/bedrijfswaardering-conflict': 'Bedrijfswaardering bij Conflict | Mijn Bedrijfswaarderingen',
  '/bedrijfswaardering-interne-overdracht': 'Bedrijfswaardering bij Interne Overdracht | Mijn Bedrijfswaarderingen',
  '/werkwijze': 'Onze Werkwijze | Mijn Bedrijfswaarderingen',
  '/over-ons': 'Over Ons | Mijn Bedrijfswaarderingen',
  '/contact': 'Contact | Mijn Bedrijfswaarderingen',
  '/cases': 'Cases | Mijn Bedrijfswaarderingen',
  '/kennisbank': 'Kennisbank | Mijn Bedrijfswaarderingen',
  '/adviseurs': 'Adviseurs | Mijn Bedrijfswaarderingen'
};
function DocumentTitle() {
  const location = useLocation();
  useEffect(() => {
    const defaultTitle = 'Mijn Bedrijfswaarderingen | Onafhankelijke bedrijfswaardering voor MKB';
    const title = PAGE_TITLES[location.pathname];
    if (title) {
      document.title = title;
    } else if (location.pathname.startsWith('/kennisbank/')) {
      document.title = 'Kennisbank | Mijn Bedrijfswaarderingen';
    } else if (location.pathname.startsWith('/cases/')) {
      document.title = 'Cases | Mijn Bedrijfswaarderingen';
    } else if (location.pathname.startsWith('/adviseurs/')) {
      document.title = 'Adviseurs | Mijn Bedrijfswaarderingen';
    } else {
      document.title = defaultTitle;
    }
  }, [location.pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <DocumentTitle data-id="element-1" />
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />

          {/* Money Pages */}
          <Route path="/bedrijfswaardering" element={<Bedrijfswaardering data-id="element-7" />} data-id="element-6" />
          <Route path="/bedrijfswaardering-verkoop" element={<Bedrijfswaardering data-id="element-9" />} data-id="element-8" />
          <Route path="/bedrijfswaardering-overname" element={<Bedrijfswaardering data-id="element-11" />} data-id="element-10" />
          <Route path="/bedrijfswaardering-scheiding" element={<Bedrijfswaardering data-id="element-13" />} data-id="element-12" />
          <Route path="/bedrijfswaardering-conflict" element={<Bedrijfswaardering data-id="element-15" />} data-id="element-14" />
          <Route path="/bedrijfswaardering-interne-overdracht" element={<Bedrijfswaardering data-id="element-17" />} data-id="element-16" />

          {/* Other Core Pages */}
          <Route path="/werkwijze" element={<Werkwijze data-id="element-19" />} data-id="element-18" />
          <Route path="/over-ons" element={<OverOns data-id="element-21" />} data-id="element-20" />
          <Route path="/contact" element={<Contact data-id="element-23" />} data-id="element-22" />

          {/* Cases */}
          <Route path="/cases" element={<Cases data-id="element-25" />} data-id="element-24" />
          <Route path="/cases/:slug" element={<CaseDetail data-id="element-27" />} data-id="element-26" />

          {/* Kennisbank (SEO Hub) */}
          <Route path="/kennisbank" element={<Kennisbank data-id="element-29" />} data-id="element-28" />
          <Route path="/kennisbank/:cluster" element={<Kennisbank data-id="element-31" />} data-id="element-30" />
          <Route path="/kennisbank/:cluster/:slug" element={<BlogPost data-id="element-33" />} data-id="element-32" />

          {/* Adviseurs */}
          <Route path="/adviseurs" element={<Adviseurs data-id="element-35" />} data-id="element-34" />
          <Route path="/adviseurs/:slug" element={<AdviseurDetail data-id="element-37" />} data-id="element-36" />
        </Routes>
      </Layout>
    </Router>;
}